import { Injectable } from '@angular/core'
import { tap } from 'rxjs/operators'
import { UserPermissionsService } from '@core/user-permissions'
import { Observable, of } from 'rxjs'
import { CookieService } from '@app/services/cookie.service'

@Injectable({ providedIn: 'root' })
export class MoveUserDataToApiService {
  constructor(
    private userPermissionsService: UserPermissionsService,
    private cookieService: CookieService
  ) {}

  public run(): Observable<any> {
    const cookieNames = ['samplestoriesmodal', 'toastNotification', 'searchName', 'notTheFirstTimeShown', 'movingStory']
    const userDataFromCookie = this.cookieService.getCookiesByNames(cookieNames)

    if (Object.keys(userDataFromCookie).length === 0) {
      return of(null)
    }

    return this.userPermissionsService.createOrUpdateUserData(userDataFromCookie).pipe(
      tap(() => {
        cookieNames.forEach((name) => {
          this.cookieService.deleteCookie(name)
          this.cookieService.deleteCookie(name, '/')
        })
      })
    )
  }
}
